import i18n from '@/plugins/i18n';
// 用户默认信息模版
export const GET_DEFAULT_USER_INFO = () => {
  return {
    // 用户菜单
    menus: null,
    // 用户信息
    userinfo: null,
    // brm token
    brmToken: null
  };
};

// 默认的 realm 值
export const DEFAULT_REALM = 0;

export const RSA_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCgEZ3Brl4bSx+YihLA5frQLTqKpueVukiUIIGB7qVnwiKg7kncKx+jWwIyOUN25oP3F1jefw3hTUOtQsPE41aCIfR2GoTNGgKy1DSC2iax1rLHQ18d/pD28jOL0/eCg4MPX/o5IwhlWDJOleF7VJ+/KcnGFq+YxgUWiMM5TZF+4wIDAQAB';

// storage key
export const LOCAL_STORAGE_KEY = {
  // 用户信息 菜单 token
  BRM_USERINFO: 'BRM_USERINFO',
  // 存储用户信息是否勾选 1-> localStorage 0-> sessionStorage
  SAVE_STORAGE_TYPE: 'SAVE_STORAGE_TYPE',
  // 进门账号登录信息
  JM_LOGIN_INFO: 'JM_LOGIN_INFO',
  // 登录类型 1：BRM登录 2：进门账号登录
  LOGIN_TYPE: 'LOGIN_TYPE',
  // 登录方式,枚举查看登录页面中的TYPE
  LOGIN_WAY: 'LOGIN_WAY',
  // realm localStorage key
  REALM_KEY: 'REALM',
  // 使用初始密码
  USE_DEFAULT_PASSWORD: 'USE_DEFAULT_PASSWORD',
  // 进门帐号体系登录
  // 进门鉴权信息 作用于进门 市场两个页面
  JM_AUTH_INFO: 'JM_AUTH_INFO',
  // 获取主线 cookie中的token
  MAIN_TOKEN: 'token',
  // 合作标识
  COOPERATION: 'COOPERATION',
  // 设备标识，用uuid代替，用于记录搜索记录
  APP_DEVICE_ID: 'APP_DEVICE_ID',
  // 全局搜索tabs需要记住的搜索和排序参数
  GLOBAL_SEARCH_MIND: 'GLOBAL_SEARCH_MIND',
  // 全局搜索-当前选中的提示词
  GLOBAL_SEARCH_HINT: 'GLOBAL_SEARCH_HINT',
  // 搜索唯一标识Map
  GLOBAL_SEARCH_ID_MAP: 'GLOBAL_SEARCH_ID_MAP',
  // 数据同步不再提示
  SYNC_NO_MORE_NOTICE: 'SYNC_NO_MORE_NOTICE',
  SYNC_BACK_NOTICED: 'SYNC_BACK_NOTICED',
  TO_SYNC_NO_MORE_NOTICE: 'TO_SYNC_NO_MORE_NOTICE',
  DO_NOT_MOVE_ANYWAY: 'DO_NOT_MOVE_ANYWAY',
  NOTE_ANCHORPOINT: 'note_anchorpoint', // 记录笔记时间戳
  NOTE_TIMESTAMP_GUIDANCE: 'note_timestamp_guidance', // 笔记功能时间戳引导提示
  NOTE_SUMMATY_DATALIST_GUIDANCE: 'note_summary_datalist_guidance', // 笔记功能摘抄指标数据引导提示
  NOTE_GROUP_MODE: 'note_group_mode', // 笔记的分组模式
  NOTE_GUIDANCE: 'note_guidance', // 笔记功能引导提示
  AI_CHAT_MODE: 'AI_CHAT_MODE', // ai进宝模式
  AUTO_SEND_PARAMS: 'AUTO_SEND_PARAMS', // ai进宝-自动发送消息参数
  /** 全局搜索-进宝Tab进入来源（一次性消费） */
  GLOBAL_SEARCH_AICHAT_ENTER_SOURCE: 'GLOBAL_SEARCH_AICHAT_ENTER_SOURCE',
  /** 全局搜索-AI搜索会员提示条：本次登录内用户是否已关闭（随退出登录清理） */
  GLOBAL_SEARCH_AI_SEARCH_BANNER_DISMISSED: 'GLOBAL_SEARCH_AI_SEARCH_BANNER_DISMISSED',
  /** 顶部入口非会员点 AI 搜索：落地全局搜索时需展示提示条的一次性标记 */
  GLOBAL_SEARCH_AI_SEARCH_BANNER_PENDING: 'GLOBAL_SEARCH_AI_SEARCH_BANNER_PENDING',
  AGENT_TYPE: 'agentType', // ai智能体类型
  MCP_SELECTED_DATA: 'MCP_SELECTED_DATA', // mcp 选中数据（废弃，改为MCP_INSTALLED_DATA）
  MCP_INSTALLED_DATA: 'MCP_INSTALLED_DATA', // mcp 工具安装状态数据
  MCP_TOOL_SELECTION: 'MCP_TOOL_SELECTION', // mcp 工具选中状态数据
  STRATEGY_PREVIEW_TYPE: 'strategy-preview-type', // 策略会预览类型
  ACTIVITY_ORIGIN_VIEW_STATE: 'activity_origin_view_state', // 活动页按来源记忆顶部视图、时间筛选与排序
  ACTIVITY_FILTER_CONFIG: 'activity_filter_config', // 活动页按来源保存筛选条件，刷新后恢复
  LANGUAGE: 'language', // 语言
  BRM_VERSION_UPDATE_NOTIFICATION: 'BRM_VERSION_UPDATE_NOTIFICATION', // 版本更新通知
  SEQUENCE: 'SEQUENCE', // 日志序列号
  DEFAULT_DATA_TRACK: 'DEFAULT_DATA_TRACK', // 默认日志数据
  DISABLE_WAF: 'DISABLE_WAF', // 禁用WAF标识（生产环境）
  ENABLE_WAF: 'ENABLE_WAF', // 启用WAF标识（非生产环境）
  VERSION_UPDATE_NOTIFICATION: 'VERSION_UPDATE_NOTIFICATION', // 版本更新通知
  REMEMBER_PASSWORD_DATA: 'REMEMBER_PASSWORD_DATA', // 记住账号密码数据
  REMEMBER_PASSWORD: 'REMEMBER_PASSWORD', // 记住密码勾选状态
  OVERSEAS_TOKEN: 'overseas-token', // 海外token
  VERSION_READ_STATE: 'VERSION_READ_STATE', // 版本已读状态
  VERSION_NEVER_REMIND: 'VERSION_NEVER_REMIND', // 版本不再提醒,
  OPEN_CHAT_MODE: 'OPEN_CHAT_MODE', // 打开进宝时上次停留的模式，取值：'chat' | 'research' | 'task'
  RESEARCH_MODE_EDITOR_TABS: 'brm-research-editor-tabs', // 研究模式中间编辑器已打开 tabs，退出登录后保留
  RESEARCH_MODE_AI_CHANGE_TOOLBAR_GUIDE: 'brm-research-ai-change-toolbar-guide', // 研究模式 AI 修改工具栏引导气泡已读状态，按账号分桶，退出登录后保留
  RESEARCH_MODE_SPREAD_AI_CHANGE_TOOLBAR_GUIDE: 'brm-research-spread-ai-change-toolbar-guide', // 研究模式表格 AI 修改工具栏引导气泡已读状态，按账号分桶，退出登录后保留
  RESEARCH_MODE_RELATED_AI_SESSIONS_GUIDE: 'brm-research-related-ai-sessions-guide', // 研究模式相关 AI 会话首次自动浮窗已读状态，按账号分桶，退出登录后保留
  RESEARCH_CHANNEL_TIP_GUIDANCE: 'research_channel_tip_guidance', // 研究模式消息频道 banner 收起入口 tooltip 首次自动展示提示
  // 研究模式消息频道 banner 展开/收起：'1' 收起 / '0' 展开。切页、刷新保留；退出登录清除后默认展开
  RESEARCH_CHANNEL_BANNER_COLLAPSED: 'research_channel_banner_collapsed',
  // 云文档侧栏目录树「展开/收起」状态记忆，按 comeinUid + goId 维度隔离，跨登录保留
  CLOUD_MENU_EXPANDED_KEYS: 'CLOUD_MENU_EXPANDED_KEYS',
  IRM_COMPANY_INFO: 'IRM_COMPANY_INFO', // IRM 公司上下文（source=irm 场景持久化）
  // 取消预约「自动预约·不再询问」偏好：记忆用户选择（关闭/继续），跨登录保留
  CANCEL_AUTO_BOOKING_PREF: 'CANCEL_AUTO_BOOKING_PREF',
  // 日程新功能导引已浏览标记，跨登录保留（同浏览器不再重复展示）
  SCHEDULE_FEATURE_TOUR: 'schedule-feature-tour',
  // 自动分身参会-自动报名风险提示关闭态，跨登录保留（同浏览器不再重复展示气泡）
  AUTO_AI_TWIN_SIGNUP_WARNING_DISMISSED: 'auto-ai-twin-signup-warning-dismissed',
  // 舆情-数据来源（微信群类型）选中状态，跨登录保留
  PUBLIC_OPINION_DATA_SOURCE: 'publicOpinion_dataSource',
  // 舆情列表表格列宽缓存，跨登录保留
  PUBLIC_OPINION_TABLE_COLUMN_WIDTH: 'publicOpinionTableColumnWidth',
  // 全局客服悬窗「展开/收起」状态：'1' 收起 / '0' 展开。会话内（切页、刷新）保留，退出登录清除以保证下次登录默认收起
  CUSTOMER_SERVICE_WIDGET_COLLAPSED: 'CUSTOMER_SERVICE_WIDGET_COLLAPSED',
  // 新手任务待庆祝的 bizType 列表：完成上报后写入，打开任务卡片时消费并播放碎纸动效，退出登录清除
  NEWBIE_TASK_PENDING_CELEBRATE: 'NEWBIE_TASK_PENDING_CELEBRATE',
  // 新手任务浮窗本次会话显隐状态：存 { uid, visible }，刷新保留，退出登录清除
  NEWBIE_TASK_VISIBLE_SESSION: 'NEWBIE_TASK_VISIBLE_SESSION',
  // 合规受限用户空闲踢出：最近活动时间戳，会话内（切页、刷新）保留，退出登录清除
  COMPLIANCE_IDLE_LAST_ACTIVE: 'COMPLIANCE_IDLE_LAST_ACTIVE',
  // 合规受限用户空闲踢出：登录时查询到的 complianceRestricted 结果，供刷新/切页复用，退出登录清除
  COMPLIANCE_RESTRICTED: 'COMPLIANCE_RESTRICTED',
  // 预约提醒历史加载成功时间戳，五分钟内不重复请求，退出登录清除
  HISTORY_REMINDERS_LOADED_AT: 'HISTORY_REMINDERS_LOADED_AT',
  // 本机正在重新登录换发鉴权信息的标记，须挺过换发流程里的 storage.clear()，故声明为跨登录保留
  AUTH_TRANSITION: 'AUTH_TRANSITION',
  // BRM access_token 刷新的跨标签页互斥锁，退出登录清除
  BRM_TOKEN_REFRESH_LOCK: 'BRM_TOKEN_REFRESH_LOCK'
};

// 存储用户信息是否勾选 1-> localStorage 0-> sessionStorage
export const SAVE_STORAGE_VALUE = {
  LOCAL: '1',
  SESSION: '0'
};

// 登录失效类错误码（字符串形式，便于与后端返回值直接比较）：命中后需引导用户重新登录
export const LOGIN_INVALID_CODES = new Set(['201', '20101', '20102', '401', '403']);

// 登录类型
export const LOGIN_TYPES = {
  // brm 帐号密码登录
  BRM: 1,
  // 进门帐号登录
  JM: 2,
  // brm 手机验证码登录
  BRM_PHONE: 3,
  // 合作方登录
  PARTNER: 4
};

// clientId
export const CLIENT_ID = 'pc-admin-web';

// 角色类型
export const ROLE_TYPE = {
  // 超级管理员
  SUPER_ADMIN: 1,
  // 管理员
  ADMIN: 2,
  // 子账号
  SUB_ACCOUNT: 3,
  COUPON_PERSON: 4
};

// 部分信息加密 加密key 16位
export const DECRYPT_KEY = 'A7#9K2$1jP!LzQ8W';

// SRS信息加密 加密key
export const SRS_KEY = '!qaz@wsx#edc';

// 环境类型
export const ENV_TYPE = {
  // 本地开发
  LOCAL: 'local',
  // 测试环境
  TEST: 'test',
  // 生产环境
  PRO: 'pro'
};

// 会议类型
export const MEETING_TYPE = {
  // 路演会议
  ROADSHOW: 1,
  // 自助会议
  SELF: 2,
  // 调研活动
  RESEARCH: 3,
  // 约访事项
  VISIT: 4,
  // 其他事项
  OTHER: 5,
  // 线下调研
  OFFLINE: 6,
  // 我司日历
  ORG_CALENDAR: 7,
  //微信平台
  WECHAT: 8
};

// 日程预约来源
export const APPOINTMENT_SOURCE = {
  // 手动预约
  MANUAL: 0,
  // 业绩会自动预约
  AUTO_PERFORMANCE: 1,
  // 专题自动预约
  AUTO_TOPIC: 2
};

// 会议类型集合
export const MEETING_TYPE_MAP = {
  [MEETING_TYPE.ROADSHOW]: 'constants.roadshow',
  [MEETING_TYPE.RESEARCH]: 'constants.research',
  [MEETING_TYPE.SELF]: 'constants.meeting',
  [MEETING_TYPE.VISIT]: 'constants.visit',
  [MEETING_TYPE.OTHER]: 'constants.other',
  [MEETING_TYPE.OFFLINE]: 'constants.offline_research',
  [MEETING_TYPE.ORG_CALENDAR]: 'schedule.meetingTypes.org_activity',
  [MEETING_TYPE.WECHAT]: '空'
};

// 修改密码方式
export const MODIFY_PASSWORD_TYPE = {
  // 原始密码
  ORIGINAL: 1,
  // 手机验证码
  OTP: 2
};

// 员工状态
export const EMP_STATUS_TYPE = {
  // 在职
  ACTIVE: 1,
  // 离职
  RESIGNED: 0
};

// 批量编辑成员的更新来源
export const EMP_UPDATE_SOURCE = {
  // BRM 管理端
  BRM: 1,
  // 运营管理后台
  MANAGEMENT: 2
};
// 会议账号类型
export const MEETING_ACCOUNT_TYPE = {
  // 免费账号
  FREE: 2,
  // 高级账号
  HIGH: 1,
  // 商业免费
  FREE_ENTERPRISE: 3,
  // 商业高级
  HIGH_ENTERPRISE: 9
};

export const MEETING_ACCOUNT_TYPE_MAP = {
  [MEETING_ACCOUNT_TYPE.HIGH]: 'constants.high_account',
  [MEETING_ACCOUNT_TYPE.FREE]: 'constants.free_account'
};
// 会议状态 1:待开始  2: 进行中  3:已结束  4:已取消 5:空状态 6:错误状态 7:已删除
export const MEETING_STATUS = {
  // 待开始
  WAIT: 1,
  // 进行中
  ING: 2,
  // 已结束
  END: 3,
  // 已取消
  CANCEL: 4,
  // 空状态
  EMPTY: 5,
  // 错误状态
  ERROR: 6,
  // 已删除
  DELETE: 7
};
// 会议状态集合
export const MEETING_STATUS_MAP = {
  [MEETING_STATUS.WAIT]: 'constants.wait',
  [MEETING_STATUS.ING]: 'constants.ongoing',
  [MEETING_STATUS.END]: 'constants.ended',
  [MEETING_STATUS.CANCEL]: 'constants.cancelled',
  [MEETING_STATUS.EMPTY]: 'constants.empty',
  [MEETING_STATUS.ERROR]: 'constants.error',
  [MEETING_STATUS.DELETE]: 'constants.deleted'
};

// 默认密码
export const DEFAULT_PASSWORD = '12345678a';

// 提醒类别
export const REMIND_TYPE = {
  0: 'constants.no_remind',
  1: 'constants.remind_on_start',
  2: 'constants.remind_5min',
  3: 'constants.remind_10min',
  4: 'constants.remind_30min',
  5: 'constants.remind_1day',
  6: 'constants.remind_1week'
};

// 我司/市场 模块 路演会议下的 tab 类型
export const ROADSHOW_TAB_TYPES = {
  //
  ALL: 0,
  // 直播预告
  LIVE_PREVIEW: 1,
  // 近期回顾
  RECENT_REVIEW: 2,
  // 我的收藏
  COLLECTION: 3,
  // 历史记录
  HISTORY: 4
};

export const JM_ROADSHOW_TYPE = {
  // 我司
  COMPANY: 2,
  // 市场
  MARKET: 1
};

// 路演会议状态
export const ROADSHOW_STATUS_MAP = {
  0: 'constants.preview',
  1: 'constants.live',
  2: 'constants.other',
  3: 'constants.playback'
  // -2：已结束、不提供回放（超过会议时间并且不提供回放、就会变成-2）
};
// 调研活动状态
export const ACTIVITIES_STATUS_MAP = {
  0: 'constants.wait',
  1: 'constants.ongoing',
  2: 'constants.ended'
};
// 自助会议状态
export const MEETINGS_STATUS_MAP = {
  1: 'constants.wait',
  2: 'constants.ongoing',
  3: 'constants.ended',
  4: 'constants.cancelled',
  5: 'constants.other',
  6: 'constants.other',
  7: 'constants.deleted'
};

//微信平台
export const WECHAT_STATUS_MAP = {
  1: 'constants.wait',
  9: 'constants.other'
};

// 会员类型
export const MEMBER_VIP_TYPE = {
  ORDINARY: '普通会员',
  CONTENT: '内容会员'
};

// 用户筛选条件类型(筛选组件)
export const USER_FILTER_TYPE = {
  // 1 纪要
  SUMMARY: 1,
  // 2 研报
  RESEARCH_REPORT: 2,
  // 3 路演
  ROADSHOW: 3,
  // 4 我司
  OUR_COMPANY: 4,
  // 5 市场
  MARKET: 5,
  // 6 日程
  SCHEDULE: 6,
  // 7 问答
  QUESTION: 7,
  // 8 策略会
  STRATEGY: 8,
  // 9 调研活动
  ACTIVITY: 9,
  // 10 合作路演
  COOPERATION_ROADSHOW: 10,
  // 10 合作纪要
  COOPERATION_SUMMARY: 11,
  // 11 合作问答
  COOPERATION_QUESTION: 12,
  // 12 ai智能搜索 开关
  AI_SEARCH: 13,
  // 14 外资研报
  OVERSEAS_RESEARCH: 14,
  // 15 观点
  VIEWPOINT: 15,
  // 16 点评
  COMMENT: 16,
  // 外资研报(全局搜索)
  OVERSEAS_GLOBAL_RESEARCH: 17,
  // 调研纪要
  RESEARCH_SUMMARY: 18,
  // 观点
  VIEWPOINT_RESEARCH_REPORT: 84,
  // 海外纪要
  OVERSEAS_SUMMARY: 19,
  // 研报图表
  REPORT_CHART: 85,
  // 财经新闻
  FINANCIAL_NEWS: 86,
  // 公众号文章
  PUBLIC_ACCOUNT_ARTICLES: 87
};

// 筛选条件类型
export const FILTER_TYPE = {
  //活动路路
  ROADSHOWMARKET: 'web_config_roadshow_list_activity',
  // 路演配置
  ROADSHOW: 'web_config_roadshow_list',
  // 内姿研报配置
  RESEARCH_REPORT: '27',
  // 外资研报配置
  OVERSEAS_RESEARCH_REPORT: '42',
  // 调研配置
  RESEARCH_ACTIVITY: '31',
  // 调研配置
  RESEARCH_ACTIVITY_INDUSTRY: '41',
  // BRM路演列表筛选
  BRM_ROADSHOW_LIST_TYPE: '43',
  // BRM活动路演列表筛选
  BRM_ACTIVITY_ROADSHOW_LIST_TYPE: '44',
  // BRM活动路演列表筛选
  BRM_WECHAT_ROADSHOW_LIST_TYPE: '88',
  // 纪要配置
  SUMMARY: 'web_config_summary_list',
  /** 海外纪要配置 */
  OVERSEAS_SUMMARY: 'web_config_overseas_summary_list',
  // 问答配置
  QUESTION: 'web_config_qa_list',
  // 调研-策略会配置
  STRATEGY: 'web_config_strategy_list',
  // 调研-调研活动
  ACTIVITY: 'web_config_research_list',
  // 全局搜索路演
  GLOBAL_SEARCH_ROADSHOW: '1',
  // 全局搜索纪要
  GLOBAL_SEARCH_SUMMARY: '24',
  // 全局搜索问答
  GLOBAL_SEARCH_QUESTION: '32',
  // 全局搜索资讯
  GLOBAL_SEARCH_CONSULT: '35',
  // 全局研报图表配置
  GLOBAL_SEARCH_RESEARCH_CHART: '34',
  // 全局搜索点评
  GLOBAL_SEARCH_COMMENT: '45',
  // 调研纪要
  RESEARCH_SUMMARY: '51',
  // AI分身任务列表
  AIAVATAR_LIST: '63',
  // AI分身任务创建
  AIAVATAR_CREATE: '64',
  // 三方搜索纪要
  THIRD_SEARCH_SUMMARY: '85',
  // 舆论列表 行业 公司筛选
  PUBLIC_OPINION: '88',
  // 点评首页
  COMMENT_LIST: '45',
  // 研报图表配置
  REPORT_CHART: '90',
  // 事件信号配置
  EVENT_SIGNAL: '92',
  // 公众号类型
  OFFICIAL_ACCOUNT_TYPE: '93',
  // 全局搜索公众号文章
  OFFICIAL_ACCOUNT: '94',
  // 财经新闻(原资讯)
  FINANCIAL_NEWS: '35',
  // 自选页-资讯
  SELF_SELECTED_NEWS: '95',
  // BRM自动预约设置
  BRM_AUTO_APPOINTMENT: '96'
};
export const RESEARCH_TYPE = {
  // 调研活动
  ACTIVITY: '0',
  // 策略会
  STRATEGY: '1'
};

// 策略会状态
export const STRATEGY_STATUS = {
  // 待开始
  1: 'constants.wait',
  // 进行中
  2: 'constants.ongoing',
  // 已结束
  3: 'constants.ended'
};
// 调研活动状态
export const ACTIVITY_STATUS = {
  1: 'constants.ongoing',
  2: 'constants.ended',
  3: 'constants.terminated',
  4: 'constants.wait'
};

// 全局搜索tab类型
export const SEARCH_TAB_TYPE = {
  // 综合
  ALL: 0,
  // 路演
  ROADSHOW: 1,
  // 纪要
  SUMMARY: 2,
  // 调研
  STRATEGY: 3,
  // 研报
  RESEARCH_REPORT: 4,
  // 问答
  QUESTION: 5,
  // 上市公司
  COMPANY: 6,
  // 日程
  SCHEDULE: 7,
  // 会议
  MEETING: 8,
  // 分析师
  ANALYST: 9,
  // 研报图表
  RESEARCH_CHART: 10,
  // 资讯-财经新闻
  FINANCIAL_NEWS: 11,
  // 点评
  COMMENT: 12,
  // 外资研报
  OVERSEAS_REPORT: 13,
  // AI进宝
  AICHAT: 14,
  // 资讯-公众号文章
  PUBLIC_ACCOUNT_ARTICLES: 15
};

// 全局搜索类型 接口类型
export const SEARCH_TYPE = {
  COMPANY: 3, // 股票
  ROADSHOW: 1, // 路演
  SUMMARY: 13, // 纪要
  COMMENT: 11, // 点评
  RESEARCH_CHART: 7, // 研报图表
  RESEARCH_REPORT: 2, // 内资研报
  OVERSEAS_REPORT: 12, // 外资研报
  STRATEGY: 5, // 调研
  QUESTION: 6, // 问答
  FINANCIAL_NEWS: 10, // 资讯
  ANALYST: 8, // 分析师
  SCHEDULE: 9, // 日程
  PUBLIC_ACCOUNT_ARTICLES: 14 // 公众号文章
};

// 全局搜索 tabType 转 接口的搜索类型
export const SEARCH_TAB_TO_TYPE = {
  [SEARCH_TAB_TYPE.ALL]: undefined, // 综合 综合tab不需要传
  [SEARCH_TAB_TYPE.COMPANY]: 3, // 股票
  [SEARCH_TAB_TYPE.ROADSHOW]: 1, // 路演
  [SEARCH_TAB_TYPE.SUMMARY]: 13, // 纪要
  [SEARCH_TAB_TYPE.COMMENT]: 11, // 点评
  [SEARCH_TAB_TYPE.RESEARCH_CHART]: 7, // 研报图表
  [SEARCH_TAB_TYPE.RESEARCH_REPORT]: 2, // 内资研报
  [SEARCH_TAB_TYPE.OVERSEAS_REPORT]: 12, // 外资研报
  [SEARCH_TAB_TYPE.STRATEGY]: 5, // 调研
  [SEARCH_TAB_TYPE.QUESTION]: 6, // 问答
  [SEARCH_TAB_TYPE.FINANCIAL_NEWS]: 10, // 资讯
  [SEARCH_TAB_TYPE.ANALYST]: 8, // 分析师
  [SEARCH_TAB_TYPE.SCHEDULE]: 9 // 日程
};

// 搜索来源 一级页面类型
export const FIRST_PAGE_ENUM = {
  GLOBAL_SEARCH: 1, // 全局搜索
  RESEARCH: 2, // 研报
  ACTIVITY: 3, // 活动
  SUMMARY: 4, // 纪要
  QA: 5, // 问答
  FIND: 6, // 发现
  SELF: 7, // 自选
  COMEIN: 8, // 进门
  FIRST: 9, // 首页
  ROAD_SHOW: 10, // 路演
  COMMENT: 11 // 点评
};

// 搜索来源 二级页面类型
export const SECOND_PAGE_ENUM = {
  COMBINE: 1, // 综合
  ROAD_SHOW: 2, // 路演
  SUMMARY: 3, // 纪要
  INVESTMENT_INSIGHTS: 4, // 点评
  STOCK: 5, // 个股
  RESEARCH: 6, // 内资研报
  RESEARCH_IMG: 7, // 研报图表
  OVERSEA_RESEARCH: 8, // 外资研报
  SURVEY: 9, // 调研
  NEWS: 10, // 资讯
  QA: 11, // 问答
  ANALYST: 12, // 分析师
  RESEARCH_VIEWS: 13, // 研报观点
  STRATEGY: 14, // 策略会
  COMEIN_PLATFORM: 15, // 进门平台
  ENTERPRISE: 16, // 企业号
  RESEARCH_INSTITUTE: 17, // 研究所
  COLUMN: 18, // 专栏
  COURSE: 19, // 课程
  SUBJECT: 20, // 专题
  SELF_MEETING: 21, // 自助会议
  SECURITIES_FIRM: 22, // 券商研究所
  IR_ENTERPRISE: 23, // IR企业号
  LISTED_COMPANY: 24, // 上市公司
  ADD_STOCK: 25, // 添加股票
  CALENDAR: 26, // 日历
  INSTITUTIONAL_ACCESS: 27, // 机构通专区
  ACTIVITY: 28, // 活动
  OVERSEAS_SUMMARY: 29, // 海外纪要
  EVENT_SIGNAL: 30 // 事件信号
};

// 搜素记录上报，二级页面类型映射
export const SECOND_PAGE_ENUM_MAP = {
  [SEARCH_TAB_TYPE.ALL]: SECOND_PAGE_ENUM.COMBINE,
  [SEARCH_TAB_TYPE.ROADSHOW]: SECOND_PAGE_ENUM.ROAD_SHOW,
  [SEARCH_TAB_TYPE.SUMMARY]: SECOND_PAGE_ENUM.SUMMARY,
  [SEARCH_TAB_TYPE.RESEARCH_REPORT]: SECOND_PAGE_ENUM.RESEARCH,
  [SEARCH_TAB_TYPE.QUESTION]: SECOND_PAGE_ENUM.QA,
  [SEARCH_TAB_TYPE.COMPANY]: SECOND_PAGE_ENUM.STOCK,
  [SEARCH_TAB_TYPE.ANALYST]: SECOND_PAGE_ENUM.ANALYST,
  [SEARCH_TAB_TYPE.STRATEGY]: SECOND_PAGE_ENUM.SURVEY,
  [SEARCH_TAB_TYPE.RESEARCH_CHART]: SECOND_PAGE_ENUM.RESEARCH_IMG,
  [SEARCH_TAB_TYPE.FINANCIAL_NEWS]: SECOND_PAGE_ENUM.NEWS,
  [SEARCH_TAB_TYPE.COMMENT]: SECOND_PAGE_ENUM.INVESTMENT_INSIGHTS,
  [SEARCH_TAB_TYPE.OVERSEAS_REPORT]: SECOND_PAGE_ENUM.OVERSEA_RESEARCH
};

// 搜索配置类型
// 1：路演
// 2：内资研报
// 3：股票
// 4：纪要
// 5：调研活动
// 6：问答
// 7：研报图表
// 11:点评
// 12：外资研报
export const QUERY_SETTING_TYPE = {
  // 内资研报
  DOMESTIC_REPORT: 2,
  // 纪要
  SUMMARY: 4,
  // 外资研报
  OVERSEAS_REPORT: 12,
  // 研报图表
  REPORT_CHART: 7
};

// 搜索联想类型
export const SEARCH_HINT_TYPE = {
  // 路演
  ROADSHOW: 1,
  // 纪要
  SUMMARY: 2,
  // 研报
  RESEARCH_REPORT: 3,
  // 外资研报
  OVERSEAS_REPORT: 4,
  // 点评
  COMMENT: 5,
  // 研报图表
  REPORT_CHART: 6,
  // 事件信号
  EVENT_SIGNAL: 7
};

// 全局搜索历史记录类型
export const SEARCH_HISTORY_TYPE = {
  // 全局搜索
  OVERALL_SITUATION: 1,
  // 日程-市场
  SCHEDULE_MARKET: 2,
  // 日程-我司
  SCHEDULE_COMPANY: 3,
  // 日程-我的
  SCHEDULE_PERSONAL: 4,
  // 日程-市场-机构
  SCHEDULE_MARKET_MECHANISM: 5,
  // 日程-市场-行业
  SCHEDULE_MARKET_INDUSTRY: 6,
  // 日程-我司-机构
  SCHEDULE_PERSONAL_MECHANISM: 7,
  // 日程-我司-行业
  SCHEDULE_PERSONAL_INDUSTRY: 8,
  // 日程-市场-上市公司
  SCHEDULE_MARKET_COMPANY: 9,
  // 日程-我司-上市公司
  SCHEDULE_PERSONAL_COMPANY: 10,
  // 路演 机构
  ROADSHOW_MECHANISM: 11,
  // 路演 行业
  ROADSHOW_INDUSTRY: 12,
  // 路演 上市公司
  ROADSHOW_COMPANY: 13,
  // 路演
  ROADSHOW: 14,
  // 纪要-机构
  SUMMARY_MECHANISM: 15,
  // 纪要-行业
  SUMMARY_INDUSTRY: 16,
  // 纪要-上市公司
  SUMMARY_COMPANY: 17,
  // 纪要-标题
  SUMMARY_TITLE: 18,
  // 纪要-主讲人
  SUMMARY_SPEAKER: 19,
  // 调研活动-机构
  STRATEGY_MECHANISM: 20,
  // 调研活动-标题
  STRATEGY_TITLE: 21,
  // 研报-标题
  RESEARCH_REPORT_TITLE: 22,
  // 研报-主讲人
  RESEARCH_REPORT_SPEAKER: 23,
  // 研报-机构
  RESEARCH_REPORT_MECHANISM: 24,
  // 研报-上市公司
  RESEARCH_REPORT_COMPANY: 25,
  // 问答-标题
  QUESTION_TITLE: 26,
  // 问答-上市公司
  QUESTION_COMPANY: 27,
  // 问答-主题
  QUESTION_THEME: 28,
  // 策略会-机构
  STRATEGY_ORG: 29,
  // 策略会-上市公司
  STRATEGY_COMPANY: 30,
  // 策略会-标题
  STRATEGY_B_TITLE: 31,
  // 路演合作页
  ROADSHOW_COOPERATION: 32,
  // 合作页路演机构
  ROADSHOW_COOPERATION_MECHANISM: 33,
  // 合作页纪要机构
  SUMMARY_COOPERATION_MECHANISM: 34,
  // 合作页纪要公司
  SUMMARY_COOPERATION_COMPANY: 35,
  // 合作页纪要
  SUMMARY_COOPERATION: 36,
  // 合作页问答关键词搜索
  QUESTION_COOPERATION: 37,
  // 合作页问答公司
  QUESTION_COOPERATION_COMPANY: 38,
  // 合作页问答主题
  QUESTION_COOPERATION_THEME: 39,
  // 问答-机构
  QUESTION_ORG: 40,
  // 首页顶部搜索历史
  INDEX_SEARCH_HISTORY: 41,
  // 活动 调研全局搜索
  ACTIVITY_GLOBAL_SEARCH: 42,
  // 调研活动-公司
  ACTIVITY_COMPANY: 43,
  // 合作页综合页面搜索框
  OVERALL_SEARCH_COOPERATION: 44,
  // 会议 会议文档列表关键词搜索
  MEETING_DOCUMENT: 45,
  //活动 会议
  ACTIVITY_MEETING: 46,
  //成员推送
  MAIL_PUSH: 47,
  // 研报-国家和地区
  RESEARCH_REPORT_COUNTRY: 48,
  // 外资研报-作者
  OVERSEAS_RESEARCH_AUTHOR: 49,
  //外资研报 - 标题
  OVERSEAS_RESEARCH_TITLE: 50,
  //外资研报 - 机构
  OVERSEAS_RESEARCH_MECHANISM: 51,
  //外资研报 - 上市公司
  OVERSEAS_RESEARCH_COMPANY: 52,
  //外资研报 - 国家和地区
  OVERSEAS_RESEARCH_COUNTRY: 53,
  //观点 - 标题
  VIEWPOINT_TITLE: 54,
  //观点 - 作者
  VIEWPOINT_SPEAKER: 55,
  //观点 - 机构
  VIEWPOINT_MECHANISM: 56,
  //观点 - 上市公司
  VIEWPOINT_COMPANY: 57,
  // 点评 机构
  COMMENT_MECHANISM: 58,
  // 点评 上市公司
  COMMENT_COMPANY: 59,
  // 点评 行业
  COMMENT_INDUSTRY: 60,
  // 内资研报 机构 （全局搜索）
  DOMESTIC_RESEARCH_MECHANISM: 61,
  // 内资研报 上市公司 （全局搜索）
  DOMESTIC_RESEARCH_COMPANY: 62,
  // 内资研报 行业 （全局搜索）
  DOMESTIC_RESEARCH_INDUSTRY: 63,
  // 外资研报 机构 （全局搜索）
  OVERSEAS_GLOBAL_RESEARCH_MECHANISM: 64,
  // 外资研报 上市公司 （全局搜索）
  OVERSEAS_GLOBAL_RESEARCH_COMPANY: 65,
  // 外资研报 行业 （全局搜索）
  OVERSEAS_GLOBAL_RESEARCH_INDUSTRY: 66,
  //研报搜索框
  REPORT_SEARCH: 69,
  // 调研纪要-机构
  RESEARCH_SUMMARY_MECHANISM: 70,
  // 调研纪要-行业
  RESEARCH_SUMMARY_INDUSTRY: 71,
  // 调研纪要-上市公司
  RESEARCH_SUMMARY_COMPANY: 72,
  // 调研纪要-标题
  RESEARCH_SUMMARY_TITLE: 73,
  // 路演-参会人
  ROADSHOW_AUTHOR: 74,
  // 点评-参会人
  COMMENT_AUTHOR: 75,
  // 外资研报-参会人（全局搜索）
  OVERSEAS_GLOBAL_RESEARCH_AUTHOR: 76,
  // 纪要-参会人
  SUMMARY_AUTHOR: 77,
  // 研报-参会人 (研报图表-参会人 共用)
  RESEARCH_REPORT_AUTHOR: 78,
  // 点评
  COMMENT_TITLE: 79,
  // 外资研报搜索框
  OVERSEAS_REPORT_SEARCH: 80,
  // 纪要-机构
  OVERSEAS_SUMMARY_MECHANISM: 81,
  // 纪要-行业
  OVERSEAS_SUMMARY_INDUSTRY: 82,
  // 纪要-上市公司
  OVERSEAS_SUMMARY_COMPANY: 83,
  // 纪要-标题
  OVERSEAS_SUMMARY_TITLE: 84,
  // 纪要-参会人
  OVERSEAS_SUMMARY_AUTHOR: 85,
  // 研报图表-作者
  REPORT_CHART_AUTHOR: 86,
  //研报图表 - 标题
  REPORT_CHART_TITLE: 87,
  //研报图表 - 机构
  REPORT_CHART_MECHANISM: 88,
  //研报图表 - 上市公司
  REPORT_CHART_COMPANY: 89,
  //研报图表 - 国家和地区
  REPORT_CHART_COUNTRY: 90,
  // 事件信号搜索框
  EVENT_SIGNAL_SEARCH: 92
};

// 获取每日路演数量类型
export const DAILY_ROADSHOW_TYPE = {
  // 市场
  MARKET: 1,
  // 我司
  OUR_COMPANY: 2,
  // 调活动
  ACTIVITY: 3,
  // 策略会
  STRATEGY: 4
};

// 问答来源
export const SOURCE_TYPE_MAP = {
  1: '路演会议',
  2: '互动易',
  3: '投关活动'
};

// 自动登录状态类型
export const AUTO_LOGIN_STATUS = {
  // 不需要自动登录
  NO_LOGIN: 0
};

// 页面级别
export const PAGE_LEVEL = {
  // 一级
  FIRST: 1,
  // 二级
  SECOND: 2,
  // 三级
  THIRD: 3
};

// 全局收藏icon类名
export const GLOBAL_COLLECTION_CLASS = 'global-collect-icon';

// 导出会议文档类型
export const EXPORT_MEETING_DOCUMENT_TYPE = {
  SUMMARY: 1,
  ABSTRACT: 2,
  1: '会议全文',
  2: '会议摘要'
};

// 导出会议文档状态
export const EXPORT_MEETING_DOCUMENT_STATUS = {
  TRANSCRIBING: 1,
  SUCCESS: 2,
  FAIL: 3,
  1: '转写中',
  2: '导出成功',
  3: '导出失败'
};

// 业绩日历类型
export const PERFORMANCE_CALENDAR_TYPE = {
  PERFORMANCE: 0,
  ROADSHOW: 1
};

// 翻译上传状态
export const TRANSLATION_UPLOAD_STATUS = {
  // 未上传
  NOT_UPLOAD: 0,
  // 上传中
  UPLOADING: 1,
  // 上传成功
  UPLOAD_SUCCESS: 2,
  // 上传失败
  UPLOAD_FAIL: 3,
  // 翻译中
  TRANSLATING: 4,
  // 翻译失败
  TRANSLATE_FAIL: 5,
  // 翻译成功
  TRANSLATE_SUCCESS: 6,
  // 翻译异常(敏感词)
  TRANSLATE_EXCEPTION: 9,
  // 上传完成前奏（需要判断是否可以翻译）
  UPLOAD_COMPLETE: 7
};
export const MAILLIST_TYPE = {
  // 推送管理
  MANAGE: '0',
  // 推送历史
  HISTORY: '1'
};

//自助会议账号激活状态
export const MEETING_ACTIVE_STATUS = {
  // 未激活
  0: 'constants.not_activated',
  // 已激活
  1: 'constants.activated',
  // 激活失败
  2: 'constants.activation_failed',
  // 激活中
  3: 'constants.activating',
  // 待接受邀请
  4: 'constants.waiting_invitation'
};

/** 自助会议账号激活状态数值（与 MEETING_ACTIVE_STATUS 键一致） */
export const MEETING_ACCOUNT_ACTIVE_STATE = {
  NOT_ACTIVATED: 0,
  ACTIVATED: 1,
  ACTIVATION_FAILED: 2,
  ACTIVATING: 3,
  WAITING_INVITATION: 4
};

// biz_common-confi接口配置类型
export const COMMON_TYPE = {
  // 会议助理
  RECORD_CONTACT: 'proxy_recording_contact_config'
};
// app下载地址
export const DOWNLOAD_APP_QRCODE = 'https://image.comein.cn/web/roadshow/co_download_qrc.png';

// 全局搜索排序类型
export const SEARCH_SORT_TYPE = {
  DEFAULT: 1,
  NEWEST: 2,
  RELATED: 3,
  HOTTEST: 4,
  EARLIEST: 5,
  // 热门内容
  HOT: 6,
  COLLECT_LATEST: 13,
  COLLECT_EARLIEST: 14,
  UNLOCK_LATEST: 15,
  UNLOCK_EARLIEST: 16,
  TRANSLATE_LATEST: 17,
  TRANSLATE_EARLIEST: 18,
  VIEW_LATEST: 19,
  VIEW_EARLIEST: 20,
  SHARE_LATEST: 21,
  SHARE_EARLIEST: 22,
  1: 'constants.sort_default', // 默认排序
  2: 'constants.latest_release', // 最新发布
  3: 'constants.relevance_first', // 相关优先
  4: 'constants.highest_popularity', // 最高热度
  5: 'constants.earliest_release', // 最早发布
  6: 'constants.hot_content', // 热门内容
  13: '最近收藏',
  14: '最早收藏',
  16: '最近解锁',
  17: '最早翻译',
  18: '最近翻译',
  19: '最近浏览',
  20: '最早浏览',
  21: '最新共享',
  22: '最早共享'
};

// 全局搜索排序类型, 特殊情况含：最高热度
export const SEARCH_SORT_TABS = [
  {
    label: 'constants.sort_default',
    value: SEARCH_SORT_TYPE.DEFAULT
  },
  {
    label: 'constants.sort_newest',
    value: SEARCH_SORT_TYPE.NEWEST
  },
  {
    label: 'constants.sort_earliest',
    value: SEARCH_SORT_TYPE.EARLIEST
  }
];
export const SEARCH_SORT_TABS_FULL = [
  {
    label: 'constants.sort_default',
    value: SEARCH_SORT_TYPE.DEFAULT
  },
  {
    label: 'constants.sort_newest_full',
    value: SEARCH_SORT_TYPE.NEWEST
  },
  {
    label: 'constants.sort_earliest_full',
    value: SEARCH_SORT_TYPE.EARLIEST
  }
];

// 全局搜索联想内容类型
export const SEARCH_WORD_TYPE = {
  // 常规输入内容
  NORMAL: 0,
  // 股票 内容
  STOCK: 1,
  // 券商 内容
  BROKER: 2,
  // 机构 内容
  MECHANISM: 3,
  // 分析师
  ANALYST: 4,
  // 题材 内容
  THEME: 5,
  // 行业 内容
  INDUSTRY: 6,
  // 会议类型标签
  MEETING_TYPE: 7,
  // 特色标签
  FEATURE: 8,
  // 市场标签
  MARKET: 9,
  // 路演
  ROADSHOW: 20,
  // 纪要
  SUMMARY: 21,
  // 内资研报
  REPORT: 22,
  // 点评
  COMMENT: 23,
  // 外资研报
  OVERSEAS_REPORT: 24,
  // 研报图表
  REPORT_CHART: 25
};

// 浏览记录类型 （用于 /api/admin/common/get-user-browse 接口）
// 新增引导弹框时必须配置 expireDate（如 '2026-12-31'），超过该日期后不再请求接口和展示引导
export const BROWSE_BEHAVIOR_TYPE = {
  // 消息中心是否查看
  MESSAGE_CENTER: {
    contentType: 3
  },
  // 问答浏览记录
  QUESTION: {
    contentType: 4
  },
  // 我的笔记 新功能引导
  NOTE_GUIDANCE: {
    contentType: 5,
    contentId: 5,
    expireDate: '2026-04-01'
  },
  // RAG 搜索升级 提示框
  RAG_SEARCH_UPGRADE: {
    contentType: 8,
    contentId: 8,
    expireDate: '2026-04-01'
  },
  // AI帮记 使用说明弹框
  AI_NOTE_USE_DIALOG: {
    contentType: 9,
    contentId: 1,
    expireDate: '2026-04-21'
  },
  // AI帮记 是否添加过会记
  AI_NODE_ADD: {
    contentType: 9,
    contentId: 2
  },
  // AI帮记 新功能引导
  AI_NOTE_GUIDANCE: {
    contentType: 9,
    contentId: 3,
    expireDate: '2026-04-01'
  },
  // 研报菜单显示新新功能
  REPORT_MENU_GUIDANCE: {
    contentType: 15,
    contentId: 15,
    expireDate: '2026-04-01'
  },
  // 菜单重构 引导图
  MENU_GUIDE: {
    contentType: 16,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // 更多菜单引导提示
  MORE_MENU_GUIDANCE: {
    contentType: 17,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // 纪要研报支持AI问答 引导
  SUMMARY_REPORT_AICHAT_GUIDE_STEP1: {
    contentType: 19,
    contentId: 1,
    expireDate: '2026-04-21'
  },
  SUMMARY_REPORT_AICHAT_GUIDE_STEP2: {
    contentType: 19,
    contentId: 2,
    expireDate: '2026-04-21'
  },
  // 纪要详情：默认打开 Tab 功能引导
  SUMMARY_DEFAULT_TAB_GUIDE: {
    contentType: 19,
    contentId: 3,
    expireDate: '2026-12-31'
  },
  MARKET_INDUSTRYCHAIN_GUIDE: {
    contentType: 20,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // 会员专区 新功能引导
  MEMBER_ZONE_GUIDE: {
    contentType: 21,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  COMMENT_GUIDE: {
    contentType: 22,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  TABLE_SWITCH_TIP: {
    contentType: 23,
    contentId: 1
  },
  TABLE_SWITCH_GUIDE: {
    contentType: 23,
    contentId: 2,
    expireDate: '2026-04-01'
  },
  QUESTION_GUIDE: {
    contentType: 24,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // ai 进宝投研大脑上新通知
  AICHAT_RESEARCH_BRAIN_NOTICE: {
    contentType: 25,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // ai 进宝投研大脑首页引导
  AICHAT_RESEARCH_BRAIN_HOME_GUIDE: {
    contentType: 25,
    contentId: 2,
    expireDate: '2026-04-21'
  },
  // ai 进宝投研大脑首页新标签
  AICHAT_RESEARCH_BRAIN_HOME_NEW: {
    contentType: 25,
    contentId: 3,
    expireDate: '2026-04-21'
  },
  // ai 进宝投研大脑思维链引导
  AICHAT_RESEARCH_BRAIN_CHAIN_GUIDE: {
    contentType: 25,
    contentId: 4,
    expireDate: '2026-04-21'
  },
  // ai 进宝思维链编辑器左侧边栏折叠后展开引导
  AICHAT_RESEARCH_BRAIN_CHAIN_LEFT_SIDEBAR_GUIDE: {
    contentType: 25,
    contentId: 5,
    expireDate: '2026-04-21'
  },
  // ai 进宝思维链编辑器右侧边栏折叠后展开引导
  AICHAT_RESEARCH_BRAIN_CHAIN_RIGHT_SIDEBAR_GUIDE: {
    contentType: 25,
    contentId: 6,
    expireDate: '2026-04-21'
  },
  // ai 进宝研究模式新手引导（资料库 → AI对话 → 工具与连接）
  AICHAT_RESEARCH_MODE_GUIDE: {
    contentType: 25,
    contentId: 7,
    expireDate: '2026-07-15'
  },
  // ai 进宝首页模式切换入口迁移引导
  AICHAT_MODE_SWITCHER_HOME_GUIDE: {
    contentType: 25,
    contentId: 8,
    expireDate: '2026-07-15'
  },
  // ai 进宝资料库批量操作入口引导（批量管理 icon 气泡，待后端确认 contentId）
  AICHAT_RESEARCH_BATCH_ENTRY_GUIDE: {
    contentType: 25,
    contentId: 9,
    expireDate: '2026-12-31'
  },
  // ai 进宝资料库批量操作内部引导（底部操作栏气泡，待后端确认 contentId）
  AICHAT_RESEARCH_BATCH_ACTION_GUIDE: {
    contentType: 25,
    contentId: 10,
    expireDate: '2026-12-31'
  },
  // ai 进宝研究模式收藏 tab 一次性引导
  AICHAT_RESEARCH_FAVORITE_TAB_GUIDE: {
    contentType: 25,
    contentId: 12,
    expireDate: '2026-12-31'
  },
  // ai 进宝左侧「技能管理」的券商研究所引流角标：一次性，点击后永久不再展示
  AICHAT_SKILL_BROKER_ENTRY_BADGE: {
    contentType: 25,
    contentId: 11
  },
  // AI 进宝定时任务「任务模版」首次进入引导（contentId 待后端确认）
  AICHAT_SCHEDULED_TASK_TEMPLATE_GUIDE: {
    contentType: 25,
    contentId: 12,
    expireDate: '2027-12-31'
  },
  // ai 进宝左侧「定时任务」的官方模板引流角标：一次性，点击定时任务入口或角标后永久不再展示
  AICHAT_SCHEDULED_TASK_TEMPLATE_ENTRY_BADGE: {
    contentType: 25,
    contentId: 13
  },
  EVENT_SIGNAL_GUIDE: {
    contentType: 26,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  // 事件信号回测引导
  EVENT_SIGNAL_BACKTEST_GUIDE: {
    contentType: 26,
    contentId: 2,
    expireDate: '2026-04-01'
  },
  // 个人中心菜单引导（服务专员、任务管理器已移至个人中心）
  USER_CENTER_MENU_GUIDANCE: {
    contentType: 28,
    contentId: 1,
    expireDate: '2026-04-21'
  },
  // openClaw 任务模式引导
  OPENCLAW_TASK_MODE_GUIDE: {
    contentType: 27,
    contentId: 1,
    expireDate: '2026-04-21'
  },
  SUMMARY_PRIVATE_PUBLIC_GUIDE: {
    contentType: 30,
    contentId: 7,
    expireDate: '2026-04-01'
  },
  NEWS_REMARK_GUIDE: {
    contentType: 29,
    contentId: 1,
    expireDate: '2026-04-01'
  },
  /** 支付弹框关闭 — 会员挽留弹窗（频次由服务端 get-user-browse 控制，含自然日/全端） */
  MEMBER_PAY_CLOSE_RETENTION: {
    contentType: 35,
    contentId: 1
  },
  // 个股研究复盘：新版 K 线打点 + 全屏模式引导
  STOCK_RESEARCH_KLINE_GUIDE: {
    contentType: 36,
    contentId: 1,
    expireDate: '2026-12-31'
  },
  // 自选列表两级分组重构：新功能指引
  SELF_SELECTED_WATCHLIST_GUIDE: {
    contentType: 37,
    contentId: 1,
    expireDate: '2026-12-31'
  },
  // 微信群详情：左右键切换消息提示条（关闭后不再展示）
  PUBLIC_OPINION_KEYBOARD_SWITCH_TIP: {
    contentType: 37,
    contentId: 1
  }
};

export const AUTH_RESULT = {
  HAS_PERMISSION: 1,
  NO_PERMISSION: 2,
  1: 'constants.has_permission',
  2: 'constants.no_permission'
};

export const NO_PERMISSION_ENUM = {
  NO_PERMISSION_1: 1,
  NO_PERMISSION_0: 0, // 新增无权限状态码
  NEED_VIP: 2,
  NEED_COIN: 3,

  0: '已设置查看权限', // 新增0状态描述
  1: '已设置查看权限', // 保持原有1状态描述
  2: '无会员',
  3: '需要支付牛币'
};

export const NEED_CHANGE_IDENTITY = {
  NO_NEED: 0,
  TO_PERSONAL: 1,
  TO_ENTERPRISE: 2,

  0: '无需切换身份',
  1: '切换到个人版',
  2: '切换到企业版'
};

// 预约按钮类型
export const APPOINTMENT_BTN_TYPE = {
  // 跳转链接
  LINK: 0,
  // 请求接口
  INTERFACE: 1,
  // 关闭弹窗
  CLOSE: 2
};

// 预约状态
export const APPOINTMENT_STATUS = {
  CANCEL: 0,
  CONFIRM: 1
};
// 审核状态
export const APPROVAL_STATUS = {
  PENDING: 1,
  PASS: 2,
  FAILED: 3
};

// 自动报名文案
export const AUTO_REPORT_TEXT = {
  DEADLINE: 'constants.autoReport.deadline',
  APPROVE_PENDING: 'constants.autoReport.approvePending',
  APPROVE_FAIL: 'constants.autoReport.approveFail',
  NOT_OPEN_SWITCH: 'constants.autoReport.notOpenSwitch',
  FAILED: 'constants.autoReport.failed'
};

/** 自动报名状态变更事件：报名信息 / 自动预约弹窗更新后广播，供日历「自动分身参会」同步风险提示 */
export const AUTO_SIGNUP_STATUS_CHANGED_EVENT = 'auto-signup-status-changed';

// ai 进宝 附件类型关联快捷问题
export const AI_ATTACHMENT_TYPE = {
  TEXT: ['txt', 'doc', 'docx', 'pdf', 'ppt', 'pptx'],
  IMAGE: ['jpg', 'jpeg', 'png', 'bmp'],
  EXCEL: ['xls', 'xlsx', 'csv']
};

// 附件类型关联的快捷问题
export const AI_ATTACHMENT_TYPE_QUESTION_LIST = {
  TEXT: [
    'aiChat.attachment_questions.summarize_document',
    'aiChat.attachment_questions.analyze_document_viewpoints',
    'aiChat.attachment_questions.brief_summary'
  ],
  IMAGE: ['aiChat.attachment_questions.describe_image', 'aiChat.attachment_questions.extract_image_text'],
  EXCEL: ['aiChat.attachment_questions.analyze_table_trends', 'aiChat.attachment_questions.generate_table_report'],
  [['TEXT', 'IMAGE'].sort().join('_')]: [
    'aiChat.attachment_questions.organize_files_summary',
    'aiChat.attachment_questions.brief_files_summary',
    'aiChat.attachment_questions.explain_image_meaning'
  ],
  [['TEXT', 'EXCEL'].sort().join('_')]: [
    'aiChat.attachment_questions.organize_files_summary',
    'aiChat.attachment_questions.brief_files_summary',
    'aiChat.attachment_questions.analyze_table_trends'
  ],
  [['IMAGE', 'EXCEL'].sort().join('_')]: [
    'aiChat.attachment_questions.analyze_table_trends',
    'aiChat.attachment_questions.generate_table_report',
    'aiChat.attachment_questions.explain_image_meaning'
  ],
  [['TEXT', 'IMAGE', 'EXCEL'].sort().join('_')]: [
    'aiChat.attachment_questions.organize_documents_summary',
    'aiChat.attachment_questions.analyze_table_trends',
    'aiChat.attachment_questions.explain_image_meaning'
  ],
  ERROR: ['aiChat.attachment_questions.summarize_attachment', 'aiChat.attachment_questions.what_is_attachment']
};
export const GENERATION_STATUS = {
  // 未生成或待开始
  NOT_STARTED: 0,
  // 生成中
  IN_PROGRESS: 1,
  // 已完成
  COMPLETED: 2,
  // 失败
  FAILED: 3,

  0: '未生成或待开始',
  1: '生成中',
  2: '已完成',
  3: '失败'
};

export const AI_NOTE_STATUS = {
  // 提交处理中
  HANDLING: 0,
  // 异常
  ABNORMAL: 1,
  // 待开始
  TO_BEGIN: 2,
  // 帮记中
  HELPING: 3,
  // 生成中
  GENERATING: 4,
  // 成功
  SUCCESS: 5,
  // 失败
  FAILED: 6
};

export const FILE_SOURCE_MAP = {
  1: 'constants.user_upload',
  2: 'constants.user_create',
  3: 'constants.ai_note',
  4: 'constants.ai_jinbao',
  5: 'constants.meeting_summary',
  6: 'constants.proxy_recording',
  7: 'constants.translate',
  8: 'constants.note',
  9: 'constants.transcribe',
  10: 'constants.third_party_link',
  99: 'constants.other',
  USERCREATE: 2,
  AINOTE: 3,
  MEETING: 5,
  PROXYRECORDING: 6,
  TRANSLATE: 7,
  NOTE: 8,
  TRANSFORM: 9,
  THIRD_PARTY_LINK: 10
};

export const AI_CHAT_SUPPORT_CODE_LANGUAGES = [
  'python',
  'java',
  'javascript',
  'c',
  'cpp',
  'csharp',
  'php',
  'ruby',
  'go',
  'rust',
  'swift',
  'kotlin',
  'dart',
  'scala',
  'lua',
  'perl',
  'haskell',
  'clojure',
  'elixir',
  'erlang',
  'html',
  'css',
  'sass',
  'scss',
  'less',
  'stylus',
  'coffeescript',
  'typescript',
  'jsx',
  'tsx',
  'vue',
  'react',
  'svelte',
  'bash',
  'powershell',
  'sql',
  'mysql',
  'postgresql',
  'sqlite',
  'latex',
  'json',
  'xml',
  'yaml',
  'toml',
  'ini',
  'graphql',
  'protobuf',
  'solidity',
  'verilog',
  'vhdl',
  'robotframework'
];

export const LANGUAGE_TO_EXTENSION = {
  python: 'py',
  java: 'java',
  javascript: 'js',
  c: 'c',
  cpp: 'cpp',
  csharp: 'cs',
  php: 'php',
  ruby: 'rb',
  go: 'go',
  rust: 'rs',
  swift: 'swift',
  kotlin: 'kt',
  dart: 'dart',
  scala: 'scala',
  lua: 'lua',
  perl: 'pl',
  haskell: 'hs',
  clojure: 'clj',
  elixir: 'ex',
  erlang: 'erl',
  html: 'html',
  css: 'css',
  sass: 'sass',
  scss: 'scss',
  less: 'less',
  stylus: 'styl',
  coffeescript: 'coffee',
  typescript: 'ts',
  jsx: 'jsx',
  tsx: 'tsx',
  vue: 'vue',
  react: 'jsx',
  svelte: 'svelte',
  bash: 'sh',
  powershell: 'ps1',
  sql: 'sql',
  mysql: 'sql',
  postgresql: 'sql',
  sqlite: 'sql',
  latex: 'tex',
  json: 'json',
  xml: 'xml',
  yaml: 'yml',
  toml: 'toml',
  ini: 'ini',
  graphql: 'graphql',
  protobuf: 'proto',
  solidity: 'sol',
  verilog: 'v',
  vhdl: 'vhdl',
  robotframework: 'robot'
};
export const SEARCH_WORD_TAG_TYPE = {
  CUSTOM_WORD: 0,
  STOCK: 1,
  ORGANIZATION: 2,
  INSTITUTION: 3,
  ANALYST: 4,
  THEME: 5,
  INDUSTRY: 6,
  MEETING_TYPE_TAG: 7,
  FEATURE_TAG: 8,
  MARKET_TAG: 9,
  ROAD_SHOW: 20,
  SUMMARY: 21,
  RESEARCH: 22,
  INVESTMENT: 23,
  OVERSEAS_RESEARCH: 24,
  0: 'common.search_tag_type.custom_supplement', // '自定义补充',
  1: 'common.search_tag_type.individual_stock', // '个股',
  2: 'common.search_tag_type.research_institute', // '研究所',
  3: 'common.search_tag_type.institution', // '机构',
  4: 'common.search_tag_type.analyst', // '分析师',
  5: 'common.search_tag_type.theme', // '题材',
  6: 'common.search_tag_type.industry', // '行业',
  7: 'common.search_tag_type.meeting_type_tag', // '会议类型标签',
  8: 'common.search_tag_type.feature_tag', // '特色标签',
  9: 'common.search_tag_type.market_tag', // '市场标签',
  20: 'common.search_tag_type.roadshow', // '路演',
  21: 'common.search_tag_type.minutes', // '纪要',
  22: 'common.search_tag_type.domestic_research_report', // '内资研报',
  23: 'common.search_tag_type.commentary', // '点评',
  24: 'common.search_tag_type.foreign_research_report' // '外资研报'
};

// 联想词面板，需要直接打开详情页的类型
export const OPEN_DETAIL_SEARCH_TYPES = [
  SEARCH_WORD_TAG_TYPE.ROAD_SHOW,
  SEARCH_WORD_TAG_TYPE.SUMMARY,
  SEARCH_WORD_TAG_TYPE.INVESTMENT,
  SEARCH_WORD_TAG_TYPE.RESEARCH,
  SEARCH_WORD_TAG_TYPE.OVERSEAS_RESEARCH
];

/**
 *  归属类型（1 我的文档 2 我的纪要 3 共享知识库 4 最近 ）
 */
export const BELONG_TYPE = {
  MY_DOCUMENTS: 1,
  MY_SUMMARY: 2,
  KNOWLEDGE: 3,
  RECENT: 4,
  TAG: 5,
  1: '我的文档',
  2: '我的纪要',
  3: '共享知识库',
  4: '最近',
  5: '标签'
};

// 不同页面来源不同
export const FILE_SOURCE_FILTER_MAP = {
  [BELONG_TYPE.MY_DOCUMENTS]: [
    { text: 'constants.user_upload', value: 1 },
    { text: 'constants.user_create', value: 2 },
    { text: 'constants.note', value: 8 },
    { text: 'constants.ai_jinbao', value: 4 },
    { text: 'constants.translate', value: 7 },
    { text: 'constants.third_party_link', value: 10 },
    { text: 'constants.other', value: 99 }
  ],
  [BELONG_TYPE.MY_SUMMARY]: [
    { text: 'constants.user_create', value: 2 },
    { text: 'cloudDocument.source_ai_note', value: 3 },
    { text: 'constants.meeting_summary', value: 5 },
    { text: 'constants.transcribe', value: 9 },
    { text: 'constants.other', value: 99 }
  ],
  [BELONG_TYPE.KNOWLEDGE]: [
    { text: 'constants.user_upload', value: 1 },
    { text: 'constants.user_create', value: 2 },
    { text: 'constants.note', value: 8 },
    { text: 'cloudDocument.source_ai_note', value: 3 },
    { text: 'constants.ai_jinbao', value: 4 },
    { text: 'constants.meeting_summary', value: 5 },
    { text: 'constants.transcribe', value: 9 },
    { text: 'constants.translate', value: 7 },
    { text: 'constants.other', value: 99 }
  ],
  [BELONG_TYPE.RECENT]: [
    { text: 'constants.user_upload', value: 1 },
    { text: 'constants.user_create', value: 2 },
    { text: 'constants.note', value: 8 },
    { text: 'cloudDocument.source_ai_note', value: 3 },
    { text: 'constants.ai_jinbao', value: 4 },
    { text: 'constants.meeting_summary', value: 5 },
    { text: 'constants.transcribe', value: 9 },
    { text: 'constants.translate', value: 7 },
    { text: 'constants.other', value: 99 }
  ],
  [BELONG_TYPE.TAG]: [
    { text: 'constants.user_upload', value: 1 },
    { text: 'constants.user_create', value: 2 },
    { text: 'constants.note', value: 8 },
    { text: 'cloudDocument.source_ai_note', value: 3 },
    { text: 'constants.ai_jinbao', value: 4 },
    { text: 'constants.meeting_summary', value: 5 },
    { text: 'constants.transcribe', value: 9 },
    { text: 'constants.translate', value: 7 },
    { text: 'constants.other', value: 99 }
  ]
};

export const FILE_TYPE_MAP = {
  // PDF
  pdf: 1,
  // WORD
  doc: 2,
  docx: 2,
  // PPT
  ppt: 3,
  pptx: 3,
  // TXT
  txt: 4,
  // IMAGE
  jpg: 5,
  jpeg: 5,
  png: 5,
  gif: 5,
  webp: 5,
  bmp: 5,
  svg: 5,
  // XLSX（含宏工作簿）
  xlsx: 10,
  xls: 10,
  xlsm: 10,
  // CSV
  csv: 11,
  // MARKDOWN
  md: 12,
  markdown: 12,
  // HTML
  html: 13,
  htm: 13,
  // 音频（与 CLOUD_DOC_FILE_TYPE.audio 对齐）
  mp3: 14,
  aac: 14,
  m4a: 14,
  flac: 14,
  wav: 14,
  // 视频（与 CLOUD_DOC_FILE_TYPE.video 对齐）
  mp4: 15,
  mkv: 15,
  mov: 15,
  avi: 15,
  webm: 15
};

export const FILE_ACCEPT_MAP =
  '.pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.webp,.bmp,.xlsx,.xls,.xlsm,.csv,.md,.markdown,.html,.htm,.mp3,.aac,.m4a,.flac,.wav,.mp4,.mkv,.mov,.avi,.webm';

// 云文档文件类型
export const CLOUD_DOCX_TYPE = {
  FOLDER: 1,
  FILE: 2,
  1: '文件夹',
  2: '文件'
};

export const CHAT_BUSINESS_TYPE = {
  WEB_TYPE: 0, //网页
  SUMMARY_TYPE: 1, //纪要
  RESEARCH_TYPE: 2, //研报
  OVERSEAS_RESEARCH_TYPE: 3, //外资研报
  INVESTMENT_TYPE: 4, //点评,
  CLOUD_DOCX_TYPE: 5, //云文档
  ANNOUNCEMENT_TYPE: 6, // 公告
  MEETING_DOCUMENT: 7, //会议文档
  NEWS_WECHAT: 10, // 公众号
  QUESTION_ANSWER: 11,
  EVENT_SIGNAL: 16, // 事件信号
  DAILY_REPORT: 17, // 进门内参
  IRM_QUESTION_ANSWER: 1002,
  IRM_SUMMARY: 1003,
  0: 'constants.chat_business_type.web',
  1: 'constants.chat_business_type.summary',
  2: 'constants.chat_business_type.research',
  3: 'constants.chat_business_type.overseas_research',
  4: 'constants.chat_business_type.investment',
  5: 'constants.chat_business_type.cloud_document',
  6: 'constants.chat_business_type.announcement',
  7: 'constants.chat_business_type.meeting_document',
  10: 'constants.chat_business_type.news_wechat',
  11: 'constants.chat_business_type.question_answer',
  16: 'constants.chat_business_type.event_signal',
  17: 'constants.chat_business_type.daily_report',
  1002: 'constants.chat_business_type.question_answer',
  1003: 'constants.chat_business_type.summary'
};

export const CLOUD_AUTH_MAP = {
  1: 'cloudDocument.manage_permissions', //可管理
  10: 'cloudDocument.edit_permissions', //可编辑
  98: 'cloudDocument.view_permissions', //可查看
  99: '移除权限',
  MANAGE: 1,
  EDIT: 10,
  CHECK: 98,
  NO_AUTH: 99
};

// 纪要详情页文字大小
export const SUMMARY_TEXT_SIZE_MAP = {
  MINI: '-2px',
  DEFAULT: '0px',
  LARGE: '3px',
  LARGE_PLUS: '6px',
  '-2px': '小号',
  '0px': '标准',
  '3px': '大号',
  '6px': '加大号',
  OPTIONS: [
    { label: 'constants.text_size_mini', value: '-2px', class: 'mini' },
    { label: 'constants.text_size_standard', value: '0px', class: 'standard' },
    { label: 'constants.text_size_large', value: '3px', class: 'large' },
    { label: 'constants.text_size_plus', value: '6px', class: 'largePlus' }
  ]
};
// 纪要详情页导出
export const SUMMARY_EXPORT_OPTIONS = [
  {
    label: 'common.noun.meeting_full_text',
    tip: 'summary.original_refined_content',
    value: '1'
  },
  {
    label: 'cloudDocument.ai_summary',
    tip: 'summary.key_chapter_qa_indicator_content',
    value: '2'
  },
  {
    label: 'summary.video_and_audio',
    tip: 'summary.not_support_send_to_email',
    value: '3'
  }
];
// 纪要详情页导出子项sourceType: video和audio; dowmLoadType: download和email
export const getSummaryExportSubOptions = (sourceType, dowmLoadType, hideSummary = false) => {
  const options = [
    { label: `common.button.${sourceType}`, labelDes: '', value: `${dowmLoadType}-source` },
    {
      label: 'common.noun.meeting_full_text',
      labelDes: i18n.global.t('summary.original_refined_content'),
      value: `${dowmLoadType}-full`
    },
    {
      label: 'common.noun.meeting_ai_summary',
      labelDes: i18n.global.t('summary.key_chapter_qa_indicator_content'),
      value: `${dowmLoadType}-summary`
    }
  ];
  if (dowmLoadType === 'email') {
    options.shift();
  }
  if (hideSummary) {
    options.pop();
  }
  return options;
};

// 纪要详情页文字大小、行高对应
export const SUMMARY_TEXT_SIZE = {
  // 小号
  [SUMMARY_TEXT_SIZE_MAP.MINI]: {
    fontSize: '13px',
    lineHeight: '24px'
  },
  // 标准
  [SUMMARY_TEXT_SIZE_MAP.DEFAULT]: {
    fontSize: '145x',
    lineHeight: '26px'
  },
  // 大号
  [SUMMARY_TEXT_SIZE_MAP.LARGE]: {
    fontSize: '18px',
    lineHeight: '30px'
  },
  // 加大号
  [SUMMARY_TEXT_SIZE_MAP.LARGE_PLUS]: {
    fontSize: '21px',
    lineHeight: '34px'
  }
};
export const AI_CHAT_SSE_STATUS = {
  THINK_START: 'THINK_START',
  THINK: 'THINK',
  THINK_END: 'THINK_END',
  DEEP_SEARCH_START: 'DEEP_SEARCH_START',
  DEEP_SEARCH_MODEL_CHAT: 'DEEP_SEARCH_MODEL_CHAT',
  DEEP_SEARCH_END: 'DEEP_SEARCH_END'
};

export const TRANSLATION_CLIENT_STATUS = {
  TRANSLATING: 0,
  SUCCESS: 1,
  FAILED: 2,
  0: '翻译中',
  1: '翻译成功',
  2: '翻译失败'
};

export const AI_NOTE_QUESTION_LIST = {
  USER_CREATION: [
    'aiChat.attachment_questions.summarize_document_content',
    'aiChat.attachment_questions.generate_mind_map'
  ],
  AI_ACCOUNTING: [
    'aiChat.attachment_questions.summarize_document_content',
    'aiChat.attachment_questions.generate_mind_map'
  ],
  MEETING_MINUTES: [
    'aiChat.attachment_questions.summarize_meeting_minutes',
    'aiChat.attachment_questions.generate_mind_map'
  ],
  TRANSLATION: ['aiChat.attachment_questions.summarize_document_content'],
  NOTE: ['aiChat.attachment_questions.summarize_document_content', 'aiChat.attachment_questions.generate_mind_map'],
  TRANSFER: ['aiChat.attachment_questions.summarize_document_content', 'aiChat.attachment_questions.generate_mind_map'],
  OTHER: ['aiChat.attachment_questions.summarize_document_content']
};
export const DOC_SOURCE_TYPE = {
  //用户创建
  USER_CREATION: 2,
  //AI参会
  AI_ACCOUNTING: 3,
  //AI进宝
  MEETING_MINUTES: 5,
  //会记纪要
  TRANSLATION: 7,
  //笔记
  NOTE: 8,
  //翻译
  TRANSFER: 9,
  //其它
  OTHER: 99
};

/**
 * 转存云文档来源业务类型（upload-document.sourceBizType）。
 * 1-会议纪要，2-内资研报，3-外资研报。
 */
export const SOURCE_BIZ_TYPE = {
  SUMMARY: 1,
  DOMESTIC_REPORT: 2,
  FOREIGN_REPORT: 3
};

export const RATING_LIST = {
  1: { name: 'constants.sell', color: '#0EB752' },
  2: { name: 'constants.buy', color: '#E53939' },
  3: { name: 'constants.reduce', color: '#0EB752' },
  4: { name: 'constants.increase', color: '#E53939' },
  5: { name: 'constants.neutral', color: '#565960' }
};
// AI工具类型 录音，转写，翻译，录会，AI分身
export const AI_TOOLS_TYPE = {
  RECORDING: 1,
  TRANSCRIPTION: 2,
  TRANSLATION: 3,
  MEETING_RECORDING: 4,
  AI_TWINS: 5,
  1: '录音',
  2: '转写',
  3: '翻译',
  4: '录会',
  5: 'AI分身'
};
export const LANG_MAP_TO_SERVER = {
  'en-US': 'en',
  'zh-CN': 'zh-cn'
};

// 筛选折叠默认值
export const FILTER_PREFERENCE = {
  RESEARCH_REPORT: [USER_FILTER_TYPE.RESEARCH_REPORT, 10],
  OVERSEAS_RESEARCH: [USER_FILTER_TYPE.OVERSEAS_RESEARCH, 10],
  SUMMARY: [USER_FILTER_TYPE.SUMMARY, 10],
  OVERSEAS_SUMMARY: [USER_FILTER_TYPE.OVERSEAS_SUMMARY, 10],
  QUESTION: [USER_FILTER_TYPE.QUESTION, 10],
  COMMENT: [USER_FILTER_TYPE.COMMENT, 10],
  REPORT_CHART: [USER_FILTER_TYPE.REPORT_CHART, 10],
  ROADSHOW: [USER_FILTER_TYPE.ROADSHOW, 10],
  ACTIVITY: [USER_FILTER_TYPE.ACTIVITY, 10],
  STRATEGY: [USER_FILTER_TYPE.STRATEGY, 10],
  FINANCIAL_NEWS: [USER_FILTER_TYPE.FINANCIAL_NEWS, 10],
  PUBLIC_ACCOUNT_ARTICLES: [USER_FILTER_TYPE.PUBLIC_ACCOUNT_ARTICLES, 10]
};

// 列表模式默认值
export const LIST_MODE_DEFAULT = {
  RESEARCH_REPORT: [USER_FILTER_TYPE.RESEARCH_REPORT, 11], // 1: 列表模式 2: 表格模式
  OVERSEAS_RESEARCH: [USER_FILTER_TYPE.OVERSEAS_RESEARCH, 11], // 1: 列表模式 2: 表格模式
  SUMMARY: [USER_FILTER_TYPE.SUMMARY, 11], // 1: 列表模式 2: 表格模式
  OVERSEAS_SUMMARY: [USER_FILTER_TYPE.OVERSEAS_SUMMARY, 11], // 1: 列表模式 2: 表格模式
  ROADSHOW: [USER_FILTER_TYPE.ROADSHOW, 11], // 1: 列表模式 2: 表格模式
  ACTIVITY: [USER_FILTER_TYPE.ACTIVITY, 11], // 1: 列表模式 2: 表格模式
  STRATEGY: [USER_FILTER_TYPE.STRATEGY, 11] // 1: 列表模式 2: 表格模式
};

/** 纪要详情默认打开二级 Tab 的用户偏好 [type, subType] */
export const SUMMARY_DETAIL_DEFAULT_TAB = [21, 2];

// 云文档的文档类型
export const CLOUD_DOC_FILE_TYPE = {
  // pdf
  pdf: 1,
  // "doc", "docx"
  word: 2,
  // "ppt", "pptx"
  ppt: 3,
  txt: 4,
  // "jpg", "png"
  image: 5,
  // 纪要
  summary: 6,
  // 翻译
  translation: 7,
  // 笔记
  note: 8,
  // 转写
  transfer: 9,
  xlsx: 10,
  csv: 11,
  markdown: 12,
  html: 13,
  /** 音频类（mp3/aac/m4a/flac/wav） */
  audio: 14,
  /** 视频类（mp4/mkv/mov/avi/webm） */
  video: 15,
  /** 三方外链（微信助手等转存的公众号/网页链接） */
  externalLink: 16,
  /** 未知/不支持的文件类型；与 FILE_TYPE_MAP 值域（1-16）不重叠 */
  OTHER: 99
};

// 云文档的文档类型对应的i18n代码cloudDocI18nCodeMap
export const CLOUD_DOC_I18N_CODE_MAP = {
  我的文档: 'cloudDocument.menu.my_document',
  我的纪要: 'cloudDocument.menu.my_summary',
  共享知识库: 'cloudDocument.menu.share_knowledge_base'
};

/** 顶部「更多」入口定位云文档「微信转存」分区的 query key */
export const FOCUS_WECHAT_ARCHIVE_QUERY_KEY = 'focusWechatArchive';
/** 顶部「更多」入口定位云文档「微信转存」分区的 query 生效值 */
export const FOCUS_WECHAT_ARCHIVE_QUERY_VALUE = '1';

// 会员相关国际化
export const MEMBER_TEXT_I18N_MAP = {
  专业版会员: 'common.member.professional_Member'
};

export const SUMMARY_TYPE_VALUE = {
  MEETING_MINUTES: 1,
  SURVEY_SUMMARY: 2,
  CLOUD_DOCUMENT: 3
};
